import { styled } from 'styled-components'

const Label = styled.label`
  display: block;
  padding: 0 12px 4px;
  color: ${(p) => p.theme.labelText};
  font-size: 12px;
  font-weight: bold;
`

export default Label
